import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleFileUploadUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={28} cy={28} r={28} fill="#999" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 14c-.83 0-1.5.67-1.5 1.5v23c0 .83.67 1.5 1.5 1.5h21c.83 0 1.5-.67 1.5-1.5v-23c0-.83-.67-1.5-1.5-1.5h-21zM36 19H20v1.8h16V19zm-16 4.3h16v1.8H20v-1.8zm8 4.3h-8v1.8h8v-1.8z"
        fill="#fff"
      />
      <circle cx={38} cy={36} r={9} fill="#CCC" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.72 31.78a.4.4 0 01.56 0l3.88 3.83a.2.2 0 01-.14.34l-2.9.05v4.3a.2.2 0 01-.2.2h-1.84a.2.2 0 01-.2-.2V36h-2.9a.2.2 0 01-.14-.34l3.88-3.88z"
        fill="#fff"
      />
    </svg>
  );
}

SvgPicCircleFileUploadUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleFileUploadUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleFileUploadUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
